<template>
  <div class="InsidePlay">
    <pre-start v-if="slug === 'pre'" @next="next('play')" />
    <play v-if="slug === 'play'" :lang="lang" />
  </div>
</template>

<script>
 // @ is an alias to /src
import PreStart from '@/components/insideplay/prestart.vue';
 import Cam from '@/components/insideplay/cam.vue';
import Play from '@/components/insideplay/play.vue';
import Language from '@/components/insideplay/language.vue';
 export default {
   name: 'PlayFinal',
   computed: {
   },
   props: {
     slug: {
       type: String,
       default: 'pre'
     },
     lang: {
       type: String,
       default: ''
     }
   },
   data () {
     return {
       disable: true,
     }
   },
   methods: {
     next (s) {
       this.$router.push({name: 'PlayPageFinal', params: { slug: s }})
     },
   },
   mounted() {
     if (!this.$store.state.auth.user) {
       this.$router.push({name: 'account', params: {type: 'login'}})
     }
      const classrooms = this.$store.state.classrooms
     /* if (classrooms.length && this.slug !== 'play') {
      *   this.$router.push({name: 'PlayPage', params: { slug: 'play' }})
      * } */
   },
   components: {
     PreStart,
     Cam,
     Play,
     Language
   }
 }
</script>

<style scoped>
.InsidePlay {
  padding-top: 10vh;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
